import { PropType, DesignableObject, Panel } from "@mcleod/components";
import { ReflectiveDialogs } from "@mcleod/components/src/base/ReflectiveDialogs";
import { makeStyles, setClassIncluded } from "@mcleod/core";
import { PropertiesTable } from "..";
import { ActionChangeComponentProperty } from "./actions/ActionChangeComponentProperty";
import { doDesignerAction } from "./UIDesignerActionHistory";

export const designerClasses = makeStyles("dsg", {
  designerSelected: { border: "2px dashed #444 !important" },
  designerContainer: { border: "1px dotted #999" },
});

export function designerHandleComponentSelection(selectedComponents: DesignableObject[], component: DesignableObject, add: boolean, tableProps: PropertiesTable) {
  if (add && selectedComponents.indexOf(component) >= 0) {
    selectedComponents.splice(selectedComponents.indexOf(component), 1);
    setClassIncluded(component, designerClasses.designerSelected, false);
    if (tableProps != null)
      tableProps.displayProperties(selectedComponents);
    return selectedComponents;
  }

  for (let i = 0; !add && i < selectedComponents.length; i++)
    setClassIncluded(selectedComponents[i], designerClasses.designerSelected, false);
  if (component == null)
    selectedComponents.length = 0;
  else {
    if (add)
      selectedComponents.push(component);
    else {
      selectedComponents.length = 0;
      selectedComponents.push(component);
    }
    if (_markAsSelected(component) === true)
      setClassIncluded(component, designerClasses.designerSelected, true);
  }
  if (tableProps != null)
    tableProps.displayProperties(selectedComponents);
  return selectedComponents;
}

function _markAsSelected(component: DesignableObject): boolean {
  return !(component instanceof Panel && component.id === "designerTabHeading");
}

export function designerApplyChangeToSelectedComponents(selectedComponents, activeTab, data, newValue, tableProps: PropertiesTable) {
  for (let i = 0; selectedComponents != null && i < selectedComponents.length; i++) {
    const comp = selectedComponents[i];
    if (data.prop.type === PropType.number && !(comp.designerDataSource != null && data.prop_name === 'maxResults')) {
      if (newValue == null || newValue.length === 0)
        comp[data.prop_name] = null;
      else
        comp[data.prop_name] = parseInt(newValue);
    } else if (data.prop.type === PropType.bool && !(comp.designerDataSource != null && (data.prop_name === 'autoSearch' || data.prop_name === 'subscribeToChanges'))) { //ick
      comp[data.prop_name] = newValue;
    }
    else {
      if (data.prop_name === "dataSource" || data.prop_name === "mainDataSource") // need to come up with a better way to reference other components on the screen
        comp[data.prop_name] = activeTab.dataSources[newValue];
      else if (comp.designerDataSource != null) {
        if (data.prop_name === "parentDataSource")
          comp.designerDataSource.parentDataSource = activeTab.dataSources[newValue];
        else {
          const currValue = comp.designerDataSource[data.prop_name];
          if (newValue !== currValue)
            comp.designerDataSource[data.prop_name] = newValue;
        }
      }
      else
        comp[data.prop_name] = newValue;
    }
  }
  if (selectedComponents.length === 1) {  // if more than one component is selected, we won't see the affected props change real-time.  Not a big deal, I guess.
    const affects = data.prop.affectsProps;
    if (affects != null)
      for (const affect of affects)
        tableProps.redisplayProp(affect, selectedComponents[0][affect]);
  }
}

export function designerCheckForPropChange(designer, data, editor) {
  if (data != null) {
    for (const selectedComponent of designer.selectedComponents)
      if (data.prop && data.prop.type === PropType.bool) {
        if (data.value !== editor.checked)
          doDesignerAction(designer, new ActionChangeComponentProperty(selectedComponent, data.prop_name, editor.checked, data.value));
      }
      else if (data.value != editor.text) {
        let idMatches = 0;
        if (data.prop_name === "id") {
          const children = designer.getActiveTab().designerPanel.getRecursiveChildren();
          for (let j = 0; j < children.length; j++) {
            const currentChild = children[j];
            if (currentChild.id === editor.text)
              idMatches = idMatches + 1;
          }
        }
        if (idMatches > 1) {
          ReflectiveDialogs.showMessage("Id already in use by another component.");
          editor.text = data.value;
        }
        else {
          let oldValue = data.value;
          let newValue = editor.text;
          if (data.prop_name === "dataSource" && typeof oldValue === "string")
            oldValue = designer.getActiveTab().dataSources[oldValue];
          if (data.prop_name === "dataSource")
            newValue = designer.getActiveTab().dataSources[newValue];
          doDesignerAction(designer, new ActionChangeComponentProperty(selectedComponent, data.prop_name, newValue, oldValue));
        }
      }
  }
}
